import { api } from "@/services/api.js";
import Router from "@/router";

export default {
  async getUsuario(context) {
    try {
      var usuario = await api.get("/ass/paywall/sessao?completa=1");
      await context.commit("UPDATE_USUARIO", usuario.data.sessao);
      await context.commit("UPDATE_LOGIN", true);
    } catch (e) {
      this.dispatch("deslogarUsuario");
    }
  },
  async getSite(context) {
    try {
      var site = await api.get("/ass/paywall/site");
      window.document.title = site.data.nomeFantasia;
      await context.commit("UPDATE_SITE", site.data);
    } catch (e) {
      console.log(e);
    }
  },
  async postUsuario(context, sessao) {
    try {
      await context.commit("UPDATE_USUARIO", sessao);
      await context.commit("UPDATE_LOGIN", true);
    } catch (e) {
      this.dispatch("deslogarUsuario");
    }
  },
  deslogarUsuario(context) {
    context.commit("UPDATE_USUARIO", {
      id: "",
      nome: "",
      email: ""
    });
    localStorage.removeItem("pwK");
    context.commit("UPDATE_LOGIN", false);
    Router.go("/login");
  }
};
